import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const UpdatePluginPrivacyAndComplianceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePluginPrivacyAndCompliance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"apiKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"privacyUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storesPersonalData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePlugin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fields"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"privacyUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"privacyUrl"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"storesPersonalData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storesPersonalData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"apiKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"apiKey"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"pluginId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"apiKey"}},{"kind":"Field","name":{"kind":"Name","value":"compliance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storesPersonalData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"privacyUrl"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"UpdatePluginPrivacyAndCompliance","document":UpdatePluginPrivacyAndComplianceDocument}} as const;
export type UpdatePluginPrivacyAndComplianceMutationVariables = Types.Exact<{
  apiKey?: Types.InputMaybe<Types.Scalars['String']['input']>;
  idPlugin: Types.Scalars['ID']['input'];
  privacyUrl?: Types.InputMaybe<Types.Scalars['String']['input']>;
  storesPersonalData?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type UpdatePluginPrivacyAndComplianceMutation = (
  { __typename: 'Mutation' }
  & { updatePlugin?: Types.Maybe<(
    { __typename: 'Plugin' }
    & Pick<Types.Plugin, 'id' | 'apiKey' | 'privacyUrl'>
    & { compliance?: Types.Maybe<(
      { __typename: 'Plugin_Compliance' }
      & Pick<Types.Plugin_Compliance, 'storesPersonalData'>
    )> }
  )> }
);

export type UpdatePluginPrivacyAndComplianceMutationFn =
  Apollo.MutationFunction<
    UpdatePluginPrivacyAndComplianceMutation,
    UpdatePluginPrivacyAndComplianceMutationVariables
  >;

/**
 * __useUpdatePluginPrivacyAndComplianceMutation__
 *
 * To run a mutation, you first call `useUpdatePluginPrivacyAndComplianceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePluginPrivacyAndComplianceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePluginPrivacyAndComplianceMutation, { data, loading, error }] = useUpdatePluginPrivacyAndComplianceMutation({
 *   variables: {
 *      apiKey: // value for 'apiKey'
 *      idPlugin: // value for 'idPlugin'
 *      privacyUrl: // value for 'privacyUrl'
 *      storesPersonalData: // value for 'storesPersonalData'
 *   },
 * });
 */
export function useUpdatePluginPrivacyAndComplianceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePluginPrivacyAndComplianceMutation,
    UpdatePluginPrivacyAndComplianceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePluginPrivacyAndComplianceMutation,
    UpdatePluginPrivacyAndComplianceMutationVariables
  >(UpdatePluginPrivacyAndComplianceDocument, options);
}
export type UpdatePluginPrivacyAndComplianceMutationHookResult = ReturnType<
  typeof useUpdatePluginPrivacyAndComplianceMutation
>;
export type UpdatePluginPrivacyAndComplianceMutationResult =
  Apollo.MutationResult<UpdatePluginPrivacyAndComplianceMutation>;
export type UpdatePluginPrivacyAndComplianceMutationOptions =
  Apollo.BaseMutationOptions<
    UpdatePluginPrivacyAndComplianceMutation,
    UpdatePluginPrivacyAndComplianceMutationVariables
  >;
